module.exports = __webpack_public_path__ + "public/images/company_img.76a421c7ef5184ce86c9a4e285644a3d.png";